import {
  DniTypeEnum,
  User,
  UserTypeEnum,
  EmployeeInfo,
} from '../../../../models';

export const ACTIONS = {
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  EMAIL: 'EMAIL',
  PASSWORD: 'PASSWORD',
  DNI: 'DNI',
  DNI_TYPE: 'DNI_TYPE',
  PHONE: 'PHONE',
  USER_ORDERS: 'USER_ORDERS',
  PRIVILEGE: 'PRIVILEGE',
  ACTIVE: 'ACTIVE',
  COMPANY: 'COMPANY',
  EMPLOYEE_INFO: 'EMPLOYEE_INFO',
  DEFAULT: 'DEFAULT',
} as const;

export type ACTIONS_TYPE =
  | { type: 'FIRST_NAME'; payload: string }
  | { type: 'LAST_NAME'; payload: string }
  | { type: 'COMPANY'; payload: string }
  | { type: 'EMAIL'; payload: string }
  | { type: 'PASSWORD'; payload: string }
  | { type: 'USER_TYPE'; payload: UserTypeEnum }
  | { type: 'DNI'; payload: string }
  | { type: 'DNI_TYPE'; payload: string }
  | { type: 'PHONE'; payload: string }
  | { type: 'PASSWORD'; payload: string }
  | { type: 'PRIVILEGE'; payload: number }
  | { type: 'EMPLOYEE_INFO'; payload: EmployeeInfo }
  | { type: 'ACTIVE'; payload: boolean }
  | { type: 'DEFAULT'; payload: Partial<User> };

export function reducer(
  state: Partial<User>,
  action: ACTIONS_TYPE
): Partial<User> {
  switch (action.type) {
    case ACTIONS.FIRST_NAME:
      return { ...state, firstName: action.payload };
    case ACTIONS.LAST_NAME:
      return { ...state, lastName: action.payload };
    case ACTIONS.COMPANY:
      return { ...state, company: action.payload };
    case ACTIONS.EMAIL:
      return { ...state, email: action.payload };
    case ACTIONS.PASSWORD:
      return { ...state, password: action.payload };
    case ACTIONS.DNI:
      return { ...state, dni: action.payload };
    case ACTIONS.DNI_TYPE:
      return { ...state, dniType: action.payload as DniTypeEnum };
    case ACTIONS.PHONE:
      return { ...state, phone: action.payload };
    case ACTIONS.PRIVILEGE:
      return { ...state, privilege: action.payload };

    case ACTIONS.ACTIVE:
      return { ...state, active: action.payload };
    case ACTIONS.DEFAULT:
      return { ...state, ...(action?.payload ?? {}) };
    default:
      return { ...state };
  }
}
